import { Box } from '@chakra-ui/react'

import type { IFAQ } from '../../data/faq'
import { FAQItem } from './FAQItem'

export const FAQList = ({ items }: { items: Array<IFAQ> }) => {
  return (
    <Box sx={{ display: 'grid', gap: 4 }}>
      {items &&
        items.length > 0 &&
        items.map((item) => {
          return <FAQItem key={item.id} item={item} />
        })}
    </Box>
  )
}
